import React, { useState } from 'react';
import { BuildingIcon, PlusIcon, EditIcon, TrashIcon, SearchIcon, AlertTriangleIcon, CheckCircleIcon, XIcon } from 'lucide-react';
interface Company {
  id: number;
  name: string;
  industry: string;
  users: number;
  status: 'active' | 'inactive';
  mrr: number;
  createdAt: string;
}
const CompanyManagement = () => {
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [companyToDelete, setCompanyToDelete] = useState<number | null>(null);
  const [companyToEdit, setCompanyToEdit] = useState<Company | null>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [companies, setCompanies] = useState<Company[]>([{
    id: 1,
    name: 'PYME Solutions',
    industry: 'Tecnología',
    users: 8,
    status: 'active',
    mrr: 2500,
    createdAt: '2023-01-15'
  }, {
    id: 2,
    name: 'Retail Express',
    industry: 'Retail',
    users: 12,
    status: 'active',
    mrr: 3200,
    createdAt: '2023-02-20'
  }, {
    id: 3,
    name: 'Manufacturing Pro',
    industry: 'Manufactura',
    users: 15,
    status: 'active',
    mrr: 4500,
    createdAt: '2023-03-10'
  }, {
    id: 4,
    name: 'Services Plus',
    industry: 'Servicios',
    users: 6,
    status: 'active',
    mrr: 1800,
    createdAt: '2023-06-05'
  }]);
  const [formData, setFormData] = useState({
    name: '',
    industry: '',
    mrr: ''
  });
  const handleCreateCompany = () => {
    if (formData.name && formData.industry && formData.mrr) {
      const newCompany: Company = {
        id: companies.length + 1,
        name: formData.name,
        industry: formData.industry,
        users: 0,
        status: 'active',
        mrr: parseFloat(formData.mrr),
        createdAt: new Date().toISOString().split('T')[0]
      };
      setCompanies([...companies, newCompany]);
      setFormData({
        name: '',
        industry: '',
        mrr: ''
      });
      setShowModal(false);
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 3000);
    }
  };
  const handleEditCompany = (company: Company) => {
    setCompanyToEdit(company);
    setShowEditModal(true);
  };
  const handleUpdateCompany = () => {
    if (companyToEdit) {
      setCompanies(companies.map(c => c.id === companyToEdit.id ? companyToEdit : c));
      setShowEditModal(false);
      setCompanyToEdit(null);
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 3000);
    }
  };
  const handleDeleteCompany = (id: number) => {
    setCompanyToDelete(id);
    setShowDeleteModal(true);
  };
  const confirmDeleteCompany = () => {
    if (companyToDelete) {
      setCompanies(companies.filter(c => c.id !== companyToDelete));
      setShowDeleteModal(false);
      setCompanyToDelete(null);
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 3000);
    }
  };
  const getCompanyToDeleteName = () => {
    const company = companies.find(c => c.id === companyToDelete);
    return company ? company.name : '';
  };
  const filteredCompanies = companies.filter(company => company.name.toLowerCase().includes(searchTerm.toLowerCase()));
  return <div data-id="element-395">
      {/* Success Toast */}
      {showSuccessToast && <div className="fixed top-4 right-4 z-50 animate-slide-in" data-id="element-396">
          <div className="bg-white border border-green-200 rounded-lg shadow-lg p-4 flex items-center space-x-3 min-w-[300px]" data-id="element-397">
            <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center" data-id="element-398">
              <CheckCircleIcon size={20} className="text-green-600" data-id="element-399" />
            </div>
            <div className="flex-1" data-id="element-400">
              <p className="font-medium text-gray-900" data-id="element-401">Cambios guardados</p>
              <p className="text-sm text-gray-500" data-id="element-402">
                Los cambios se han guardado exitosamente
              </p>
            </div>
            <button onClick={() => setShowSuccessToast(false)} className="text-gray-400 hover:text-gray-600" data-id="element-403">
              <XIcon size={18} data-id="element-404" />
            </button>
          </div>
        </div>}
      <div className="mb-6 flex items-center justify-between" data-id="element-405">
        <div data-id="element-406">
          <h1 className="text-2xl font-bold text-gray-800" data-id="element-407">
            Gestión de Empresas
          </h1>
          <p className="text-gray-600" data-id="element-408">
            Administra todas las empresas de la plataforma
          </p>
        </div>
        <button onClick={() => setShowModal(true)} className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-409">
          <PlusIcon size={20} data-id="element-410" />
          <span data-id="element-411">Nueva empresa</span>
        </button>
      </div>
      {/* Search and Filters */}
      <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm mb-6" data-id="element-412">
        <div className="flex items-center space-x-4" data-id="element-413">
          <div className="flex-1 relative" data-id="element-414">
            <SearchIcon size={20} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-415" />
            <input type="text" placeholder="Buscar empresas..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-416" />
          </div>
          <select className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-417">
            <option data-id="element-418">Todas las industrias</option>
            <option data-id="element-419">Tecnología</option>
            <option data-id="element-420">Retail</option>
            <option data-id="element-421">Manufactura</option>
            <option data-id="element-422">Servicios</option>
          </select>
        </div>
      </div>
      {/* Companies Table */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-423">
        <div className="overflow-x-auto" data-id="element-424">
          <table className="w-full" data-id="element-425">
            <thead className="bg-gray-50 border-b border-gray-200" data-id="element-426">
              <tr data-id="element-427">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-428">
                  Empresa
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-429">
                  Industria
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-430">
                  Usuarios
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-431">
                  Mensualidad
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-432">
                  Estado
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-433">
                  Fecha de creación
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-434">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-435">
              {filteredCompanies.map(company => <tr key={company.id} className="hover:bg-gray-50" data-id="element-436">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-437">
                    <div className="flex items-center" data-id="element-438">
                      <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center" data-id="element-439">
                        <BuildingIcon size={20} className="text-blue-600" data-id="element-440" />
                      </div>
                      <div className="ml-3" data-id="element-441">
                        <p className="text-sm font-medium text-gray-900" data-id="element-442">
                          {company.name}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-443">
                    <span className="text-sm text-gray-600" data-id="element-444">
                      {company.industry}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-445">
                    <span className="text-sm text-gray-900" data-id="element-446">
                      {company.users}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-447">
                    <span className="text-sm font-medium text-gray-900" data-id="element-448">
                      ${company.mrr.toLocaleString()}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-449">
                    <span className={`px-2 py-1 text-xs font-medium rounded-full ${company.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'}`} data-id="element-450">
                      {company.status === 'active' ? 'Activa' : 'Inactiva'}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-451">
                    {new Date(company.createdAt).toLocaleDateString('es-ES')}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right" data-id="element-452">
                    <div className="flex items-center justify-end space-x-2" data-id="element-453">
                      <button onClick={() => handleEditCompany(company)} className="p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors" data-id="element-454">
                        <EditIcon size={16} data-id="element-455" />
                      </button>
                      <button onClick={() => handleDeleteCompany(company.id)} className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors" data-id="element-456">
                        <TrashIcon size={16} data-id="element-457" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
      {/* Edit Company Modal */}
      {showEditModal && companyToEdit && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-458">
          <div className="bg-white rounded-xl p-6 max-w-md w-full" data-id="element-459">
            <h3 className="text-xl font-semibold mb-4" data-id="element-460">Editar empresa</h3>
            <div className="space-y-4" data-id="element-461">
              <div data-id="element-462">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-463">
                  Nombre de la empresa
                </label>
                <input type="text" value={companyToEdit.name} onChange={e => setCompanyToEdit({
              ...companyToEdit,
              name: e.target.value
            })} placeholder="Ej: Tech Solutions" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-464" />
              </div>
              <div data-id="element-465">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-466">
                  Industria
                </label>
                <select value={companyToEdit.industry} onChange={e => setCompanyToEdit({
              ...companyToEdit,
              industry: e.target.value
            })} className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-467">
                  <option value="" data-id="element-468">Seleccionar industria</option>
                  <option value="Tecnología" data-id="element-469">Tecnología</option>
                  <option value="Retail" data-id="element-470">Retail</option>
                  <option value="Manufactura" data-id="element-471">Manufactura</option>
                  <option value="Servicios" data-id="element-472">Servicios</option>
                  <option value="Salud" data-id="element-473">Salud</option>
                  <option value="Educación" data-id="element-474">Educación</option>
                </select>
              </div>
              <div data-id="element-475">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-476">
                  Mensualidad
                </label>
                <input type="number" value={companyToEdit.mrr} onChange={e => setCompanyToEdit({
              ...companyToEdit,
              mrr: parseFloat(e.target.value)
            })} placeholder="2500" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-477" />
              </div>
            </div>
            <div className="flex justify-end space-x-3 mt-6" data-id="element-478">
              <button onClick={() => {
            setShowEditModal(false);
            setCompanyToEdit(null);
          }} className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-479">
                Cancelar
              </button>
              <button onClick={handleUpdateCompany} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-480">
                Guardar cambios
              </button>
            </div>
          </div>
        </div>}
      {/* Delete Confirmation Modal */}
      {showDeleteModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-481">
          <div className="bg-white rounded-xl p-6 max-w-md w-full" data-id="element-482">
            <div className="flex items-center space-x-3 mb-4" data-id="element-483">
              <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center" data-id="element-484">
                <AlertTriangleIcon size={24} className="text-red-600" data-id="element-485" />
              </div>
              <div data-id="element-486">
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-487">
                  Eliminar empresa
                </h3>
                <p className="text-sm text-gray-500" data-id="element-488">
                  Esta acción no se puede deshacer
                </p>
              </div>
            </div>
            <p className="text-gray-700 mb-6" data-id="element-489">
              ¿Estás seguro de que deseas eliminar{' '}
              <span className="font-medium" data-id="element-490">{getCompanyToDeleteName()}</span>?
              Todos los datos asociados a esta empresa se perderán
              permanentemente.
            </p>
            <div className="flex justify-end space-x-3" data-id="element-491">
              <button onClick={() => {
            setShowDeleteModal(false);
            setCompanyToDelete(null);
          }} className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-492">
                Cancelar
              </button>
              <button onClick={confirmDeleteCompany} className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors" data-id="element-493">
                Eliminar empresa
              </button>
            </div>
          </div>
        </div>}
      {/* Create Company Modal */}
      {showModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-494">
          <div className="bg-white rounded-xl p-6 max-w-md w-full" data-id="element-495">
            <h3 className="text-xl font-semibold mb-4" data-id="element-496">Nueva empresa</h3>
            <div className="space-y-4" data-id="element-497">
              <div data-id="element-498">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-499">
                  Nombre de la empresa
                </label>
                <input type="text" value={formData.name} onChange={e => setFormData({
              ...formData,
              name: e.target.value
            })} placeholder="Ej: Tech Solutions" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-500" />
              </div>
              <div data-id="element-501">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-502">
                  Industria
                </label>
                <select value={formData.industry} onChange={e => setFormData({
              ...formData,
              industry: e.target.value
            })} className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-503">
                  <option value="" data-id="element-504">Seleccionar industria</option>
                  <option value="Tecnología" data-id="element-505">Tecnología</option>
                  <option value="Retail" data-id="element-506">Retail</option>
                  <option value="Manufactura" data-id="element-507">Manufactura</option>
                  <option value="Servicios" data-id="element-508">Servicios</option>
                  <option value="Salud" data-id="element-509">Salud</option>
                  <option value="Educación" data-id="element-510">Educación</option>
                </select>
              </div>
              <div data-id="element-511">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-512">
                  Mensualidad
                </label>
                <input type="number" value={formData.mrr} onChange={e => setFormData({
              ...formData,
              mrr: e.target.value
            })} placeholder="2500" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-513" />
              </div>
            </div>
            <div className="flex justify-end space-x-3 mt-6" data-id="element-514">
              <button onClick={() => setShowModal(false)} className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-515">
                Cancelar
              </button>
              <button onClick={handleCreateCompany} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-516">
                Crear empresa
              </button>
            </div>
          </div>
        </div>}
    </div>;
};
export default CompanyManagement;